/*eslint-disable*/
import React, { useState, useEffect, useRef, useCallback } from "react";
import Highlighter from "react-highlight-words";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Input,
  Typography,
  Popover,
  Button,
  Modal,
  Spin,
  Space,
  Select,
  Row,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import MyTable from "../components/table";
import { deleteEnquiry, getEnquiry } from "../Actions/enquiryAction";
import ViewEnquiry from "./ViewEnquiry";

const { Text, Title } = Typography;

const Enquiries = (props) => {
  const { itemKey, currentUser } = props;
  const dispatch = useDispatch();

  const { enquiries, isGetEnquiryLoading, isDeletInquiryLoading } = useSelector(
    (state) => state.enquiries
  );

  useEffect(() => {
    dispatch(getEnquiry());
  }, []);

  return (
    <Spin spinning={isGetEnquiryLoading || isDeletInquiryLoading}>
      {enquiries && (
        <AllEnquiries
          data={enquiries}
          handleDialog={() => setCreateDialog(true)}
          itemKey={itemKey}
          currentUser={currentUser}
        />
      )}
    </Spin>
  );
};
export default Enquiries;

const AllEnquiries = (props) => {
  const { enquiries } = useSelector((state) => state.enquiries);
  const { itemKey, currentUser } = props;

  const columns = () => {
    let cols = [
      {
        title: "Full name",
        dataIndex: "full_name",
        key: "1",
        width: 100,
        render: (text) => text || "-",
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "2",
        width: 80,
        render: (text) => text || "-",
      },
      {
        title: "Phone number",
        dataIndex: "phone",
        key: "3",
        width: 100,
        render: (text) => text || "-",
      },
      {
        title: "Comments",
        dataIndex: "comments",
        key: "9",
        width: 100,
        render: (text) => text || "-",
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "10",
        width: 80,
        render: (created_at) => {
          if (!created_at) return "-";
          const formattedDate = moment(created_at, [
            "YYYY-MM-DD",
            "DD/MM/YYYY",
            "MM/DD/YYYY",
            "YYYY-MM-DDTHH:mm:ss.SSSZ",
            "x",
            "X",
          ]).format("DD/MM/YYYY hh:mm A");

          return (
            <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
          );
        },
      },
      {
        title: "Action",
        dataIndex: "id",
        key: "id",
        fixed: "right",
        width: 100,
        render: (id) => (
          <ActionComponent
            id={id}
            itemKey={itemKey}
            currentUser={currentUser}
          />
        ),
      },
    ];

    return cols;
  };
  return (
    <>
      <Row
        className="rowWithPadding"
        justify="space-between"
        style={{ marginBottom: "10px " }}
      >
        <Col>
          <Title level={4} style={{ marginTop: "2px" }}>
            All Inquiries
          </Title>
        </Col>
      </Row>
      <MyTable
        columns={columns(enquiries)}
        data={props.data}
        // onRowSelect={(record) => onRowSelect(record)}
      />
    </>
  );
};
const ActionComponent = ({ id, itemKey, currentUser }) => {
  const { enquiries } = useSelector((state) => state.enquiries);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const dispatch = useDispatch();

  const enquiry = enquiries.find((e) => e.id === id);

  const handleView = () => {
    setSelectedEnquiry(enquiry);
    setViewOpen(true);
    setPopoverVisible(false);
  };

  const handleDeleteEnquiry = () => {
    dispatch(deleteEnquiry(id, successDeleteEnquiry, failureDeleteEnquiry));
  };

  const successDeleteEnquiry = () => {
    dispatch(getEnquiry());
    message.success("You have successfully deleted inquiry");
  };

  const failureDeleteEnquiry = () => {
    message.error("Something went wrong.");
  };

  const content = (
    <div>
      <Button type="link" onClick={handleView}>
        View
      </Button>

      {currentUser?.role === "Admin" && (
        <Popconfirm title="Sure to delete?" onConfirm={handleDeleteEnquiry}>
          <Button type="link" danger>
            Delete
          </Button>
        </Popconfirm>
      )}
    </div>
  );

  return (
    <>
      <Popover
        content={content}
        open={popoverVisible}
        trigger="click"
        onOpenChange={setPopoverVisible}
      >
        <Button type="link">Action</Button>
      </Popover>

      <ViewEnquiry
        open={viewOpen}
        onClose={() => setViewOpen(false)}
        enquiry={selectedEnquiry}
      />
    </>
  );
};
